export default __webpack_public_path__ + "static/media/counter.8134171a.svg";